import { useMemo } from 'react';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';

import FORMATTERS from 'helpers/formatters';
import { CustomCard, Value } from '_components/Settings/components/SettingsV2/styles';
import { Skeleton } from '_components/_core';

import { Circle, StyledProgressBar, SummaryTable } from './styles';

const VARIANT_COLOR = {
  warning: 'rgb(0, 161, 194)',
  danger: 'rgb(237, 104, 4)',
  success: 'rgb(153, 102, 255)',
};

function ChargesStatusPieChart({ data, isLoading }) {
  const orderedSummary = useMemo(() => {
    if (!data || !data.charges_summary) {
      return [];
    }

    return orderBy(data.charges_summary, ['quantity', 'sort_order'], ['desc', 'asc']);
  }, [data]);

  return (
    <CustomCard className="p-3 mb-3">
      <div className="w-100 flex-column d-flex justify-content-between align-items-start">
        <Value>Situação das cobranças</Value>
      </div>
      {isLoading ? <Skeleton className="mt-1 mb-2" /> : null}
      {!isLoading && !isEmpty(orderedSummary) && (
        <>
          <StyledProgressBar className="mt-2">
            {orderedSummary.map((item, index) => (
              <StyledProgressBar
                key={`income${index}`}
                id={item.variant}
                now={item.amount}
                isLast={index === orderedSummary.length - 1}
              />
            ))}
          </StyledProgressBar>
          <SummaryTable className="mt-3 table table-hover">
            <thead>
              <tr>
                <th className="text-left">STATUS</th>
                <th className="text-right">QTDE</th>
                <th className="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {orderedSummary
                .filter(item => item.quantity > 0)
                .map(item => (
                  <tr key={item.status_id}>
                    <td className="text-left">
                      <span className="d-flex align-items-center">
                        <Circle color={VARIANT_COLOR[item.variant]} className="ml-2" />
                        {item.status}
                      </span>
                    </td>
                    <td className="text-right financial-value">
                      <span className="mr-2">{item.quantity}</span>
                    </td>
                    <td className="text-right financial-value">
                      <span className="mr-2">{FORMATTERS.NUMBER(item.amount)}</span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </SummaryTable>
        </>
      )}
    </CustomCard>
  );
}

ChargesStatusPieChart.defaultProps = {
  data: null,
  isLoading: false,
};

ChargesStatusPieChart.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default ChargesStatusPieChart;
